import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.js';
import './index.css'; // Wichtig für Tailwind (dein Design!)

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);